module.exports = __webpack_public_path__ + "img/gjtz.d42a191f.png";